import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { InfraLayout } from '../InfraLayout';
import { InfraEntities } from "../InfraEntities";
import { InfraRouterProps } from "../InfraRouterProps";

interface MonitorListPageProps extends NSARouterMakerResult, InfraRouterProps { }

export default class MonitorListPage extends Component<MonitorListPageProps>
{
    override render()
    {
        return (
            <InfraLayout
                {...this.props}
                pages={{
                    entity: InfraEntities.monitor(this.props),
                    list: {}
                }}
            >
                <></>
            </InfraLayout>
        );
    }
}